/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { useState, useEffect } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { apiUrl } from '../utilities/apiUrl';
import { ChatbotSidePanel } from './Chatbot/ChatbotSidePanel';

// Dedicated chatbot page hides the floating side panel in favor of its own layout.
const CHATBOT_PAGE_PATH = '/chatbot';

export const CheckLogIn = () => {
  const [checkIfLoggedIn, setCheckedIfLoggedIn] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [empId, setEmpId] = useState('');
  const location = useLocation();

  /**
   * automatically run when page starts loading.
   *
   * Calls the check if logged in endpoint using browser cookies.
   * Redirection might be necessary depending on the authenticity of the cookies.
   */
  useEffect(() => {
    fetch(apiUrl('/auth/'), {
      method: 'GET',
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((data) => {
        setCheckedIfLoggedIn(true);
        setIsLoggedIn(data.success);
        setEmpId(data._id);
      })
      .catch((err) => {
        console.log(err);
      });
  });

  return checkIfLoggedIn ? (
    isLoggedIn ? (
      <>
        <Outlet context={[empId]} />
        {location.pathname !== CHATBOT_PAGE_PATH && <ChatbotSidePanel />}
      </>
    ) : (
      <Navigate to="/" />
    )
  ) : (
    <div />
  );
};
